import { gql } from "@apollo/client";

export default gql`
  mutation createUser($data: CreateUserInput!){
    createUser(data: $data){
        success
        data{
            _id
            name
            surname
            role
            phone
            email
            createdAt
        }
        code
        message
    }
}
`
